import { render, staticRenderFns } from "./chooseModel.vue?vue&type=template&id=72e8a9e4&scoped=true"
import script from "./chooseModel.vue?vue&type=script&lang=js"
export * from "./chooseModel.vue?vue&type=script&lang=js"
import style0 from "./chooseModel.vue?vue&type=style&index=0&id=72e8a9e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8a9e4",
  null
  
)

export default component.exports